import React, {FC, useMemo} from 'react'
import {AssetsPage} from './AssetsPage'
import { useUserSections } from '../../context/UserSectionContext';
import { userSections } from '../../enums/userSections';
import { FallbackView } from '../../../_metronic/partials';
import { Redirect } from 'react-router-dom';
import { DEFAULT_ROUTE } from '../../routing/routes.config';
const AssetsPageWrapper: FC = () => {
  const {sections, loading} = useUserSections();
  const hasAssets = useMemo(() => {
      if(loading)
        return null;

      return sections.some(s => s.section.trim() === userSections.ASSETS);
  }, [sections, loading]);


  console.log(hasAssets);
  
  if(hasAssets === null || loading)
    return <FallbackView />

  if(!hasAssets)
      return <Redirect to={DEFAULT_ROUTE} />

  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>Assets</PageTitle> */}
      <AssetsPage />
    </>
  )
}

export default AssetsPageWrapper
